import React from "react";
import InformationCard from "./InformationCard";
import {
    faLineChart,
    faTachometer,
    faNetworkWired
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Info.css";

function Info() {
  return (
    <div className="info-section" id="services">
      <div className="info-title-content">
        <h3 className="info-title">
          <span>What We Do</span>
        </h3>
        <p className="info-description">
            By engaging Remote DBA, our customers gain peace-of-mind when it comes to operational uptime and availability of their database applications. Our remote DBA support services can be customized to fit your specific requirements and budget.
        </p>
          <h5 className="info-title">
              Why Our Customers Choose TechiesHub
          </h5>
          <p className="info-description">
              While most of our customers may have access to database development and administration capabilities in-house, they are looking to supplement their existing set of resources with a remote DBA service that can provide comprehensive coverage in areas of database administration, 24X7 monitoring, issue resolution, proactive performance management and for on-demand consulting services.
          </p>
      </div>

      <div className="info-cards-content">
        <InformationCard
          title="1. Database & Middleware Support"
          description="We will help you to achieve business goals by design and implement comprehensive data systems.$
           Detailed assessment of your database infrastructure whether running on Oracle infrastructures, Postgres, Mongo, MySQL or SQL server$
           Co/Outsource the daily management, maintenance and support of your database environments on a 24/7 basis$
           We will help your organizations navigate the complexities of database licensing, ensuring you save money, optimize resources and stay compliant$
           We will help you with all types of version upgrades & Patches$
           We help businesses create, implement and test strategies to protect and restore critical data after a disruptive event."
          icon={faNetworkWired}
        />

        <InformationCard
          title="2. Database Performance Tuning"
          description="We will Improved response and uptime of your database environment$
          We will ensure your data is easily accessible, available, and scalable to deliver better application experiences$
          We will Leverage automation and AI to save your business time and money"
          icon={faTachometer}
        />

        <InformationCard
          title="3. Infrastucture Monitoring"
          description="We will provide you with the best Infrastucture Monitoring tools$
          We will provide 24/7 Proactively response on issues before they impact your system availability$
          We will provide visibility into everything that connects database and application performance, including deep insights into queries and key metrics"
          icon={faLineChart}
        />
      </div>
    </div>
  );
}

export default Info;
